import { defineMessage } from 'services/localization';

export const messages = {
    text1: defineMessage('approvalmax_allows_to_m_se_orders_learnmorelink'),
    learnMoreLinkText: defineMessage('learn_more'),
    text2: defineMessage('see_videolink_on_how_to_ls_with_purchase_orders'),
    videoUrl: defineMessage('video'),
};
